import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, onBeforeUnmount, ref } from '@nuxtjs/composition-api';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import BravadoProgressChartV2 from '@/components/common/BravadoProgressChartV2/BravadoProgressChartV2.vue';
import { uid } from '@/components/utils/core/uid';
import { events, CountDown, CancelableNoticeError } from '@/components/common/CancelableNotice/utils';
import { NOTICE_EVENT } from '@/components/common/CancelableNotice/constants';
import type { ICancelableNotice, INoticePayload } from '@/components/common/CancelableNotice/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'CancelableNotice',
  setup(__props) {

const notices = ref<ICancelableNotice[]>([]);

function updateCounter(nextCount: number, noticeId: string): void {
  const noticeIndex = notices.value.findIndex(notice => notice.id === noticeId);

  if (noticeIndex === -1) return;

  notices.value[noticeIndex].count = nextCount;
}

function updateProgress(nextProgress: number, noticeId: string): void {
  const noticeIndex = notices.value.findIndex(notice => notice.id === noticeId);

  if (noticeIndex === -1) return;

  const notice = notices.value[noticeIndex];

  notice.progress = nextProgress;

  if (nextProgress === 100) {
    notice.resolve();
    notices.value.splice(noticeIndex, 1);
  }
}

function showNotice({ message, count = 3, cancelActionTitle, resolve, reject }: INoticePayload): void {
  if (!message) {
    reject(new CancelableNoticeError('Empty message provided'));
    return;
  }

  const id = uid();
  const countDown = new CountDown(count, id, updateCounter, updateProgress);

  notices.value.push({ id, message, cancelActionTitle, counter: countDown, count, progress: 0, resolve, reject });

  countDown.start();
}

function handleCancel(canceledNotice: ICancelableNotice): void {
  const noticeIndex = notices.value.findIndex(notice => notice.id === canceledNotice.id);

  canceledNotice.counter.stop();
  canceledNotice.reject(new CancelableNoticeError('Action has been cancelled'));

  notices.value.splice(noticeIndex, 1);
}

onBeforeMount(() => {
  events.$on(NOTICE_EVENT, showNotice);
});

onBeforeUnmount(() => {
  events.$off(NOTICE_EVENT, showNotice);
});

return { __sfc: true,notices, updateCounter, updateProgress, showNotice, handleCancel, BravadoButtonV3, BravadoProgressChartV2 }
}

})